//@ts-check
import { proxy, subscribe } from 'valtio';
// todo: refactor structure with support of hideNext=false
export const notHideableModalsWithoutForce = new Set([
    'app-status',
    'divkit:nonclosable',
    'only-connect-server',
]);
export const activeModalStack = proxy([]);
export const insertActiveModalStack = (name, newModalStack = activeModalStacks[name]) => {
    hideModal(undefined, undefined, { restorePrevious: false, force: true });
    activeModalStack.splice(0, activeModalStack.length, ...newModalStack);
    const last = activeModalStack.at(-1);
    if (last)
        showModalInner(last);
};
export const activeModalStacks = {};
window.activeModalStack = activeModalStack;
/**
 * @returns true if operation was successful
 */
const showModalInner = (modal) => {
    const cancel = modal.elem?.show?.();
    return true;
};
export const showModal = (elem) => {
    const resolved = typeof elem === 'string' ? { reactType: elem } : elem;
    const curModal = activeModalStack.at(-1);
    if ((resolved.reactType && resolved.reactType === curModal?.reactType) || !showModalInner(resolved))
        return;
    activeModalStack.push(resolved);
};
window.showModal = showModal;
/**
 *
 * @returns true if previous modal was restored
 */
export const hideModal = (modal = activeModalStack.at(-1), data = undefined, options = {}) => {
    const { force = false, restorePrevious = true } = options;
    if (!modal)
        return;
    let cancel = [...notHideableModalsWithoutForce].some(m => modal.reactType.startsWith(m)) ? !force : undefined;
    if (force) {
        cancel = undefined;
    }
    if (!cancel) {
        const lastModal = activeModalStack.at(-1);
        for (let i = activeModalStack.length - 1; i >= 0; i--) {
            if (activeModalStack[i].reactType === modal.reactType) {
                activeModalStack.splice(i, 1);
                break;
            }
        }
        const newModal = activeModalStack.at(-1);
        if (newModal && lastModal !== newModal && restorePrevious) {
            // would be great to ignore cancel I guess?
            showModalInner(newModal);
        }
        return true;
    }
};
export const hideCurrentModal = (_data, onHide) => {
    if (hideModal(undefined, undefined)) {
        onHide?.();
    }
};
export const hideAllModals = () => {
    while (activeModalStack.length > 0) {
        if (!hideModal())
            break;
    }
    return activeModalStack.length === 0;
};
export const openOptionsMenu = (group) => {
    showModal({ reactType: `options-${group}` });
};
const syncModalStackBody = () => {
    document.body.style.setProperty('--has-modals-z', activeModalStack.length ? '-1' : null);
    document.body.classList.toggle('has-open-modals', activeModalStack.length > 0);
};
subscribe(activeModalStack, syncModalStackBody);
syncModalStackBody();
// ---
export const currentContextMenu = proxy({ items: [], x: 0, y: 0 });
export const showContextmenu = (items, { clientX, clientY }) => {
    Object.assign(currentContextMenu, {
        items,
        x: clientX,
        y: clientY,
    });
};
// ---
export const miscUiState = proxy({
    currentDisplayQr: null,
    currentTouch: null,
    hasErrors: false,
    singleplayer: false,
    flyingSquid: false,
    wanOpened: false,
    wanOpening: false,
    hadConnected: false,
    /** wether game hud is shown (in playing state) */
    gameLoaded: false,
    showUI: true,
    showDebugHud: false,
    loadedServerIndex: '',
    /** currently trying to load or loaded mc version, after all data is loaded */
    loadedDataVersion: null,
    fsReady: false,
    singleplayerAvailable: false,
    usingGamepadInput: false,
    appConfig: null,
    displaySearchInput: false,
    displayFullmap: false,
    fullscreen: false,
    /** User opted in to portrait→landscape CSS rotation (`body.rotated`). */
    displayRotationEnabled: false,
    /** `innerWidth < innerHeight` — used to show the rotate button on mobile. */
    viewportPortrait: false,
    disconnectedCleanup: null
});
export const maybeCleanupAfterDisconnect = () => {
    if (miscUiState.disconnectedCleanup) {
        miscUiState.disconnectedCleanup.callback();
        miscUiState.disconnectedCleanup = null;
    }
};
window.miscUiState = miscUiState;
export const isGameActive = (foregroundCheck) => {
    if (foregroundCheck && activeModalStack.length)
        return false;
    return miscUiState.gameLoaded;
};
const updateFullscreen = () => {
    miscUiState.fullscreen = !!document.fullscreenElement;
};
document.documentElement.addEventListener('fullscreenchange', () => {
    updateFullscreen();
});
updateFullscreen();
// state that is not possible to get via bot and in-game specific
export const gameAdditionalState = proxy({
    isFlying: false,
    isSprinting: false,
    isSneaking: false,
    isZooming: false,
    warps: [],
    noConnection: false,
    poorConnection: false,
    viewerConnection: false,
    usingServerResourcePack: false,
    typingUsers: [],
});
window.gameAdditionalState = gameAdditionalState;
